export function removeSlashFromTheEnd(_string: string): string {
  _string = (_string || "").trim();
  return _string.endsWith("/") ? _string.slice(0, -1) : _string;
}
